import { generateId as f } from "@allmaps/id";
import { Image as g } from "@allmaps/iiif-parser";
import { GcpTransformer as i } from "@allmaps/transform";
import { lonLatToWebMecator as M, computeBbox as s, bboxToRectangle as h, rectanglesToScale as p, getPropertyFromCacheOrComputation as n, mixPoints as l, fetchImageInfo as k } from "@allmaps/stdlib";
import { applyTransform as t } from "../shared/matrix.js";
import { WarpedMapEvent as T, WarpedMapEventType as j } from "../shared/events.js";
const c = {
  maxOffsetRatio: 0.05,
  maxDepth: 2,
  differentHandedness: !0
}, d = !0;
function G() {
  return {
    visible: d
  };
}
function L() {
  return (u, e, r) => new P(u, e, r);
}
class P extends EventTarget {
  mapId;
  georeferencedMap;
  gcps;
  projectedGcps;
  projectedGeoPoints;
  projectedGeoPreviousTransformedResourcePoints;
  projectedGeoTransformedResourcePoints;
  resourcePreviousLongerMask;
  resourcePreviousMask;
  resourceLongerMask;
  resourceMask;
  resourceMaskBbox;
  resourceMaskRectangle;
  resourceFullMask;
  resourceFullMaskBbox;
  resourceFullMaskRectangle;
  imageInformations;
  imageId;
  parsedImage;
  loadingImageInfo;
  fetchFn;
  abortController;
  visible;
  transformationType;
  transformer;
  projectedPreviousTransformer;
  projectedTransformer;
  transformerByTransformationType = /* @__PURE__ */ new Map();
  projectedTransformerByTransformationType = /* @__PURE__ */ new Map();
  geoMask;
  geoMaskBbox;
  geoMaskRectangle;
  geoFullMask;
  geoFullMaskBbox;
  geoFullMaskRectangle;
  projectedGeoPreviousLongerMask;
  projectedGeoLongerMask;
  projectedGeoMask;
  projectedGeoMaskBbox;
  projectedGeoMaskRectangle;
  projectedGeoFullMask;
  projectedGeoFullMaskBbox;
  projectedGeoFullMaskRectangle;
  resourceToProjectedGeoScale;
  distortionMeasure;
  // The properties below are for the current viewport
  currentBestScaleFactor;
  currentTileZoomLevel;
  currentOverviewTileZoomLevel;
  currentResourceViewportRing = [];
  currentResourceViewportRingBbox;
  currentFetchableTiles = [];
  currentOverviewFetchableTiles = [];
  /**
   * Creates an instance of WarpedMap.
   *
   * @constructor
   * @param {string} mapId - ID of the map
   * @param {GeoreferencedMap} georeferencedMap - Georeferenced map used to construct the WarpedMap
   * @param {WarpedMapOptions} [options] - options
   */
  constructor(e, r, o) {
    super(), o = {
      ...G(),
      ...o
    }, this.mapId = e, this.georeferencedMap = r, this.gcps = this.georeferencedMap.gcps, this.projectedGcps = this.gcps.map(({ resource: a, geo: m }) => ({
      resource: a,
      geo: M(m)
    })), this.projectedGeoPoints = this.projectedGcps.map(
      (a) => a.geo
    ), this.resourceMask = this.georeferencedMap.resourceMask, this.updateResourceMaskProperties(), this.resourceFullMask = [
      [0, 0],
      [this.georeferencedMap.resource.width, 0],
      [
        this.georeferencedMap.resource.width,
        this.georeferencedMap.resource.height
      ],
      [0, this.georeferencedMap.resource.height]
    ], this.resourceFullMaskBbox = s(this.resourceFullMask), this.resourceFullMaskRectangle = h(this.resourceFullMaskBbox), this.imageInformations = o.imageInformations, this.loadingImageInfo = !1, this.visible = o.visible || d, this.fetchFn = o.fetchFn, this.transformationType = o.transformation?.type || this.georeferencedMap.transformation?.type || "polynomial", this.updateTransformerProperties();
  }
  /**
   * Get resourceMask in viewport coordinates
   *
   * @param {Viewport} viewport - the current viewport
   * @returns {Ring}
   */
  getViewportMask(e) {
    return this.projectedGeoMask.map((r) => t(e.projectedGeoToViewportTransform, r));
  }
  /**
   * Get Bbox of resourceMask in viewport coordinates
   *
   * @param {Viewport} viewport - the current viewport
   * @returns {Bbox}
   */
  getViewportMaskBbox(e) {
    return s(this.getViewportMask(e));
  }
  /**
   * Get resourceMaskRectangle in viewport coordinates
   *
   * @param {Viewport} viewport - the current viewport
   * @returns {Rectangle}
   */
  getViewportMaskRectangle(e) {
    return this.projectedGeoMaskRectangle.map((r) => t(e.projectedGeoToViewportTransform, r));
  }
  /**
   * Get resourceFullMask in viewport coordinates
   *
   * @param {Viewport} viewport - the current viewport
   * @returns {Ring}
   */
  getViewportFullMask(e) {
    return this.projectedGeoFullMask.map((r) => t(e.projectedGeoToViewportTransform, r));
  }
  /**
   * Get bbox of rresourceFullMask in viewport coordinates
   *
   * @param {Viewport} viewport - the current viewport
   * @returns {Bbox}
   */
  getViewportFullMaskBbox(e) {
    return s(this.getViewportFullMask(e));
  }
  /**
   * Get resourceFullMaskRectangle in viewport coordinates
   *
   * @param {Viewport} viewport - the current viewport
   * @returns {Rectangle}
   */
  getViewportFullMaskRectangle(e) {
    return this.projectedGeoFullMaskRectangle.map((r) => t(e.projectedGeoToViewportTransform, r));
  }
  /**
   * Get scale of the warped map, in resource pixels per viewport pixels.
   *
   * @param {Viewport} viewport - the current viewport
   * @returns {number}
   */
  getResourceToViewportScale(e) {
    return p(
      this.resourceMaskRectangle,
      this.getViewportMaskRectangle(e)
    );
  }
  /**
   * Get scale of the warped map, in resource pixels per canvas pixels.
   *
   * @param {Viewport} viewport - the current viewport
   * @returns {number}
   */
  getResourceToCanvasScale(e) {
    return this.getResourceToViewportScale(e) / e.devicePixelRatio;
  }
  /**
   * Get the reference scaling from the forward transformation of the projected Helmert transformer
   *
   * @returns {number}
   */
  getReferenceScale() {
    const e = n(
      this.projectedTransformerByTransformationType,
      "helmert",
      () => new i(this.projectedGcps, "helmert", c)
    );
    return e.forwardTransformation || e.createForwardTransformation(), e.forwardTransformation.scale;
  }
  /**
   * Update the resourceMask loaded from a georeferenced map to a new mask.
   *
   * @param {Ring} resourceMask
   */
  setResourceMask(e) {
    this.resourceMask = e, this.updateResourceMaskProperties(), this.updateGeoMask(), this.updateProjectedGeoMask(), this.updateResourceToProjectedGeoScale();
  }
  /**
   * Update the transformationType loaded from a georeferenced map to a new transformation type.
   *
   * @param {TransformationType} transformationType
   */
  setTransformationType(e) {
    this.transformationType = e, this.updateTransformerProperties();
  }
  /**
   * Set the distortionMeasure
   *
   * @param {DistortionMeasure} [distortionMeasure] - the disortion measure
   */
  setDistortionMeasure(e) {
    this.distortionMeasure = e, this.updateDistortionProperties();
  }
  /**
   * Update the Ground Controle Points loaded from a georeferenced map to new Ground Controle Points.
   *
   * @param {GCP[]} gcps
   */
  setGcps(e) {
    this.gcps = e, this.updateTransformerProperties(!1);
  }
  // TODO: connect/merge setCurrentBestScaleFactor and setCurrentTileZoomLevel
  // Once triangulation will not be updated directly after setting best scale factor
  // This also includes allowing undefined
  // TODO: change 'current best' to 'current' scale factor
  /**
   * Set the bestScaleFactor for the current viewport
   *
   * @param {number} scaleFactor - scale factor
   * @returns {boolean}
   */
  setCurrentBestScaleFactor(e) {
    const r = this.currentBestScaleFactor != e;
    return r && (this.currentBestScaleFactor = e), r;
  }
  /**
   * Set the tile zoom level for the current viewport
   *
   * @param {number} [tileZoomLevel] - tile zoom level
   */
  setCurrentTileZoomLevel(e) {
    this.currentTileZoomLevel = e;
  }
  /**
   * Set the overview tile zoom level for the current viewport
   *
   * @param {TileZoomLevel} [tileZoomLevel] - tile zoom level
   */
  setCurrentOverviewTileZoomLevel(e) {
    this.currentOverviewTileZoomLevel = e;
  }
  /**
   * Set resourceViewportRing at current viewport
   *
   * @param {Ring} [resourceViewportRing]
   */
  setCurrentResourceViewportRing(e) {
    this.currentResourceViewportRing = e, this.currentResourceViewportRingBbox = e ? s(e) : void 0;
  }
  /**
   * Set tiles at current viewport
   *
   * @param {FetchableTile[]} fetchableTiles
   */
  setCurrentFetchableTiles(e) {
    this.currentFetchableTiles = e;
  }
  /**
   * Set overview tiles at current viewport
   *
   * @param {FetchableTile[]} overviewFetchableTiles
   */
  setCurrentOverviewFetchableTiles(e) {
    this.currentOverviewFetchableTiles = e;
  }
  /**
   * Reset current values
   */
  resetCurrent() {
    this.setCurrentTileZoomLevel(), this.setCurrentOverviewTileZoomLevel(), this.setCurrentResourceViewportRing(), this.setCurrentFetchableTiles([]), this.setCurrentOverviewFetchableTiles([]);
  }
  /**
   * Reset the previous points and values.
   */
  resetPrevious() {
    this.projectedPreviousTransformer = this.projectedTransformer, this.projectedGeoPreviousTransformedResourcePoints = this.projectedGeoTransformedResourcePoints, this.resourcePreviousMask = this.resourceMask, this.resourcePreviousLongerMask = this.resourceLongerMask, this.projectedGeoPreviousLongerMask = this.projectedGeoLongerMask;
  }
  /**
   * Mix the previous and new points and values.
   *
   * @param {number} t
   */
  mixPreviousAndNew(e) {
    this.projectedGeoPreviousTransformedResourcePoints = this.projectedGeoTransformedResourcePoints.map((r, o) => l(
      r,
      this.projectedGeoPreviousTransformedResourcePoints[o],
      e
    )), this.projectedGeoPreviousLongerMask = this.projectedGeoLongerMask.map(
      (r, o) => l(r, this.projectedGeoPreviousLongerMask[o], e)
    );
  }
  /**
   * Check if warpedMap has image info
   *
   * @returns {this is WarpedMapWithImageInfo}
   */
  hasImageInfo() {
    return this.imageId !== void 0 && this.parsedImage !== void 0;
  }
  /**
   * Fetch and parse the image info, and generate the image ID
   *
   * @async
   * @returns {Promise<void>}
   */
  async loadImageInfo() {
    try {
      this.loadingImageInfo = !0;
      const e = this.georeferencedMap.resource.id;
      let r;
      if (this.imageInformations?.get(e))
        r = this.imageInformations.get(e);
      else {
        this.abortController = new AbortController();
        const o = this.abortController.signal;
        r = await k(e, { signal: o }, this.fetchFn), this.abortController = void 0, this.imageInformations?.set(e, r);
      }
      this.parsedImage = g.parse(r), this.imageId = await f(e), this.dispatchEvent(new T(j.IMAGEINFOLOADED));
    } catch (e) {
      throw this.loadingImageInfo = !1, e;
    } finally {
      this.loadingImageInfo = !1;
    }
  }
  updateResourceMaskProperties() {
    this.resourceMaskBbox = s(this.resourceMask), this.resourceMaskRectangle = h(this.resourceMaskBbox), this.resourcePreviousMask || (this.resourcePreviousMask = this.resourceMask);
  }
  updateTransformerProperties(e = !0) {
    this.updateTransformer(e), this.updateProjectedTransformer(e), this.updateProjectedGeoTransformedResourcePoints(), this.updateGeoMask(), this.updateFullGeoMask(), this.updateProjectedGeoMask(), this.updateProjectedFullGeoMask(), this.updateResourceToProjectedGeoScale();
  }
  updateTransformer(e = !0) {
    this.transformer = n(
      this.transformerByTransformationType,
      this.transformationType,
      () => new i(
        this.gcps,
        this.transformationType,
        c
      ),
      e
    );
  }
  updateProjectedTransformer(e = !0) {
    this.projectedTransformer = n(
      this.projectedTransformerByTransformationType,
      this.transformationType,
      () => new i(
        this.projectedGcps,
        this.transformationType,
        c
      ),
      e
    ), this.projectedPreviousTransformer || (this.projectedPreviousTransformer = this.projectedTransformer);
  }
  updateProjectedGeoTransformedResourcePoints() {
    this.projectedGeoTransformedResourcePoints = this.gcps.map(
      (e) => this.projectedTransformer.transformForward(e.resource)
    ), this.projectedGeoPreviousTransformedResourcePoints || (this.projectedGeoPreviousTransformedResourcePoints = this.projectedGeoTransformedResourcePoints);
  }
  updateGeoMask() {
    this.geoMask = this.transformer.transformForwardAsGeojson([
      this.resourceMask
    ]), this.geoMaskBbox = s(this.geoMask), this.geoMaskRectangle = this.transformer.transformForward(
      [this.resourceMaskRectangle],
      { maxDepth: 0 }
    )[0];
  }
  updateFullGeoMask() {
    this.geoFullMask = this.transformer.transformForwardAsGeojson([
      this.resourceFullMask
    ]), this.geoFullMaskBbox = s(this.geoFullMask), this.geoFullMaskRectangle = this.transformer.transformForward(
      [this.resourceFullMaskRectangle],
      { maxDepth: 0 }
    )[0];
  }
  updateProjectedGeoMask() {
    this.projectedGeoMask = this.projectedTransformer.transformForward([
      this.resourceMask
    ])[0], this.projectedGeoMaskBbox = s(this.projectedGeoMask), this.projectedGeoMaskRectangle = this.projectedTransformer.transformForward(
      [this.resourceMaskRectangle],
      { maxDepth: 0 }
    )[0], this.resourceLongerMask = this.projectedTransformer.transformForward(
      [this.resourceMask],
      { returnDomain: "inverse" }
      // refine this lineString but return resource coordinates
    )[0], this.resourcePreviousLongerMask || (this.resourcePreviousLongerMask = this.resourceLongerMask);
    const e = this.resourceLongerMask.length < this.resourcePreviousLongerMask.length, r = this.resourceLongerMask.length > this.resourcePreviousLongerMask.length;
    e && (this.resourceLongerMask = this.resourcePreviousLongerMask), this.projectedGeoLongerMask = this.projectedTransformer.transformForward(
      this.resourceLongerMask,
      { inputIsMultiGeometry: !0 }
      // treat the input as an array of points instead of a lineString to refine
    ), (!this.projectedGeoPreviousLongerMask || r) && (this.projectedGeoPreviousLongerMask = this.projectedPreviousTransformer.transformForward(
      this.resourceLongerMask,
      {
        inputIsMultiGeometry: !0
      }
    ));
  }
  updateProjectedFullGeoMask() {
    this.projectedGeoFullMask = this.projectedTransformer.transformForward([
      this.resourceFullMask
    ])[0], this.projectedGeoFullMaskBbox = s(this.projectedGeoFullMask), this.projectedGeoFullMaskRectangle = this.projectedTransformer.transformForward(
      [this.resourceFullMaskRectangle],
      { maxDepth: 0 }
    )[0];
  }
  updateResourceToProjectedGeoScale() {
    this.resourceToProjectedGeoScale = p(
      this.resourceMaskRectangle,
      this.projectedGeoMaskRectangle
    );
  }
  updateDistortionProperties() {
  }
  destroy() {
    this.abortController && this.abortController.abort();
  }
}
export {
  L as createWarpedMapFactory,
  P as default
};
//# sourceMappingURL=WarpedMap.js.map
